import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  bold: {
    fontWeight: 800,
  },
}))

function GoalAssists({ assists, players }) {
  const classes = useStyles();

  if(!assists.length){
    return 'The goal was unassisted.';
  }

  return (
    <>
      The goal was assisted by{' '}
      <span className={classes.bold}>{players[assists[0].id].name} ({assists[0].total})</span>
      { assists[1] ? (
        <>
          {' '} and <span className={classes.bold}>{players[assists[1].id].name} ({assists[1].total})</span>.{' '}
        </>
      ): '. '}
    </>
  )
}

export default GoalAssists;
